import Services from './index';
import {
  GET_DOMAIN_URL,
  UPDATE_DOMAIN_URL,
  UPDATE_ALL_DOMAIN_URL,
  DELETE_DOMAIN_URL,
  BUY_DOMAIN_URL,
  SEARCH_DOMAIN_URL,
  SETUP_DOMAIN_URL,
  CREATE_DOMAIN_URL,
  GET_ALL_DOMAIN_GROUP_URL,
  CREATE_DOMAIN_GROUP_URL,
  DELETE_DOMAIN_GROUP_URL,
  MIGRATE_DOMAIN_GROUP_URL,
  LOAD_DOMAIN_IN_GROUP_URL,
  FLUSH_DOMAIN,
  // SAVE_DID_URL,
  SAVE_DOMAIN_GROUP_SETTING_URL,
  STATS_SERVLET_URL,
  SEARCH_DIALOGS_BY_DOMAIN,
  RELEASE_DOMAIN_NOW,
  RELEASE_EACH_DOMAIN,
  GET_ALL_INACTIVE_DOMAIN_URL,
  BUY_BY_BATCH_URL,
  GET_BUYING_PROCESS_URL,
  DISMISS_BUYING_PROCESS_URL,
  RESET_DOMAIN_GROUP_URL,
  MERGE_DOMAIN_GROUP_URL,
  SPLIT_DOMAIN_GROUP_URL,
  FIND_DOMAIN_SIMILAR_URL,
} from 'consts/api';

class DomainServices {
  getCampaignDomain({ domainGroupId = '', limit = 5, offset = 0 }) {
    return Services.post(
      `${STATS_SERVLET_URL}?action=searchDomainGroup&domainGroupId=${domainGroupId}&limit=${limit}&offset=${offset}`
    );
  }

  getResponderDomain({ domainGroupId = '', page = 0, size = 15 }) {
    return Services.post(SEARCH_DIALOGS_BY_DOMAIN, {
      domainGroupId,
      page,
      size,
    });
  }

  saveDomainGroupSetting(domainGroupId, body) {
    // The deployed cloud-webapp proxy forwards the request body but drops query
    // params, so carry groupId in the body too — its sibling endpoints
    // (loadDomainsInGroup, releaseNow, migrate) already send their params in the
    // body. The ?groupId= query is kept for the native/direct path. [TEX-240]
    return Services.post(`${SAVE_DOMAIN_GROUP_SETTING_URL}?groupId=${domainGroupId}`, {
      ...body,
      groupId: domainGroupId,
    });
  }

  flushDomain(groupId) {
    return Services.get(`${FLUSH_DOMAIN}?groupId=${groupId}`);
  }

  getDomain() {
    return Services.get(GET_DOMAIN_URL);
  }

  addDomain(body) {
    return Services.post(CREATE_DOMAIN_URL, body);
  }

  updateDomain(body) {
    return Services.post(UPDATE_DOMAIN_URL, body);
  }

  updateAllDomain() {
    return Services.post(UPDATE_ALL_DOMAIN_URL);
  }

  deleteDomain(body) {
    return Services.post(DELETE_DOMAIN_URL, body);
  }

  buyDomain(body) {
    return Services.post(BUY_DOMAIN_URL, body);
  }

  searchDomain(body, configs) {
    return Services.post(SEARCH_DOMAIN_URL, body, configs);
  }

  findDomainSimilar(
    body = {
      tld: '',
      price_from: 0,
      price_to: 100,
      quantity: 30,
      unicodeIncluded: false,
      domain: 'yk5l,ho269',
    }
  ) {
    return Services.post(FIND_DOMAIN_SIMILAR_URL, body);
  }

  setupDomain(body) {
    return Services.post(SETUP_DOMAIN_URL, body);
  }

  // Domain-group
  getAllDomainGroup(body) {
    return Services.post(GET_ALL_DOMAIN_GROUP_URL, body);
  }

  createDomainGroup(name) {
    return Services.post(CREATE_DOMAIN_GROUP_URL, { name, active: true });
  }

  deleteDomainGroup(id) {
    return Services.post(DELETE_DOMAIN_GROUP_URL, { id });
  }

  migrateDomainGroup(body) {
    return Services.post(MIGRATE_DOMAIN_GROUP_URL, body);
  }

  loadDomainsInGroup({ groupId, sortField, sortDirection, startDateHour, endDateHour }) {
    return Services.post(LOAD_DOMAIN_IN_GROUP_URL, {
      groupId,
      sortField,
      sortDirection,
      startDateHour,
      endDateHour,
    });
  }

  resetDomainInGroup({ groupId = '', body }) {
    return Services.put(`${RESET_DOMAIN_GROUP_URL}?groupId=${groupId}`, body);
  }

  getAllInActiveDomain() {
    return Services.post(GET_ALL_INACTIVE_DOMAIN_URL, {});
  }

  releaseNow(body = { groupId: '', releaseThreshold: '' }) {
    return Services.post(RELEASE_DOMAIN_NOW, body);
  }

  releaseDomain(body = { domains: '' }) {
    return Services.post(RELEASE_EACH_DOMAIN, body);
  }

  buyByBatch(body = {}) {
    return Services.post(BUY_BY_BATCH_URL, body);
  }

  getBuyingProcess(groupId = '') {
    return Services.get(`${GET_BUYING_PROCESS_URL}?groupId=${groupId}`);
  }

  dismissBuyingProcessNoti({ groupId = '', id = '' }) {
    return Services.get(`${DISMISS_BUYING_PROCESS_URL}?groupId=${groupId}&id=${id}`);
  }

  mergeDomainGroup({ newDomainGroupName = '', domainGroupIds = [], deleteOriginalGroup }) {
    return Services.post(MERGE_DOMAIN_GROUP_URL, {
      newDomainGroupName,
      domainGroupIds,
      deleteOriginalGroup,
    });
  }

  splitDomainGroup({ groupId, amount }) {
    return Services.get(`${SPLIT_DOMAIN_GROUP_URL}?groupId=${groupId}&amount=${amount}`);
  }
}

export default new DomainServices();
